import * as React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { CreateRequestForm } from "./CreateRequest";
import { useGetHeadings } from "@/hooks/useGetHeadings";

interface CreateRequestDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    initialData?: { name: string; content: string };
    type: "discuss" | "research";
}

const CreateRequestDialog: React.FC<CreateRequestDialogProps> = ({
    open,
    onOpenChange,
    initialData,
    type,
}) => {
    const shouldFetch = open && !!initialData?.content && !initialData.name;
    const relatedQuestions = React.useMemo(() => (shouldFetch ? [initialData!.content] : []), [shouldFetch, initialData]);

    const { data: headingsData, isLoading: isGettingHeadings } = useGetHeadings(relatedQuestions);
    const [generatedName, setGeneratedName] = React.useState<string>("");

    React.useEffect(() => {
        if (open && initialData?.name) {
            setGeneratedName(initialData.name);
        } else if (shouldFetch && !isGettingHeadings) {
            console.log("headingsData", headingsData?.headings);
            if (headingsData?.headings) {
                const headings = Object.values(headingsData.headings);
                if (headings.length > 0) {
                    setGeneratedName(headings[0] as string); // Assuming headings are strings
                } else {
                    setGeneratedName(
                        initialData?.content && initialData.content.length > 50
                            ? initialData.content.substring(0, 50) + "..."
                            : initialData?.content || ""
                    );
                }
            } else {
                setGeneratedName(
                    initialData?.content && initialData.content.length > 50
                        ? initialData.content.substring(0, 50) + "..."
                        : initialData?.content || ""
                );
            }
        }
    }, [open, initialData, headingsData, isGettingHeadings, shouldFetch]);

    const dataToPass = React.useMemo(
        () => (initialData ? { ...initialData, name: generatedName || initialData.name } : undefined),
        [initialData, generatedName]
    );

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[600px] h-[80vh] p-0 flex flex-col gap-0">
                <DialogHeader className="px-4 py-3 border-b">
                    <DialogTitle>Save to Request Library</DialogTitle>
                </DialogHeader>
                <div className="flex-1 overflow-hidden">
                    <CreateRequestForm
                        initialData={dataToPass}
                        type={type}
                        onCancel={() => onOpenChange(false)}
                        onSuccess={() => onOpenChange(false)}
                        isGeneratingTitle={isGettingHeadings}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default CreateRequestDialog;
